import { type DocNode } from '@atlaskit/adf-schema';
import type { PublicPluginAPI } from '@atlaskit/editor-common/types';
import { JSONTransformer } from '@atlaskit/editor-json-transformer';
import { Node as PMNode } from '@atlaskit/editor-prosemirror/model';
import { Transform } from '@atlaskit/editor-prosemirror/transform';
import type { AIPlugin } from '@atlassian/editor-plugin-ai';

const transformer = new JSONTransformer();

type API = PublicPluginAPI<[AIPlugin]> | undefined;

/**
 * Ensures the response is a valid document that we are trying to insert
 * This fixes a number of issues where the BE returns a partial response and context is lost
 * on insertion
 */
export function makeDocumentValid(
	api: API,
	response: DocNode | undefined,
): { adfDoc: DocNode | undefined; doc?: PMNode } {
	const schema = api?.core.sharedState.currentState()?.schema;
	if (!schema || !response) {
		return { adfDoc: response };
	}
	try {
		const doc = schema.node('doc', null, [schema.node('paragraph', null, [])]);
		const transform = new Transform(doc);

		const node = PMNode.fromJSON(schema, response);
		const newDoc = transform.replaceWith(0, 2, node).doc;
		return {
			doc: newDoc,
			adfDoc: transformer.encode(newDoc) as DocNode,
		};
	} catch (e) {
		return { adfDoc: response };
	}
}
